export default __webpack_public_path__ + "static/pillar-4-6b3a7d6938345bde6d3b49162581bd42.jpg";